import { Component } from '@angular/core';
import { Subject, Subscription, combineLatest, takeUntil } from 'rxjs';
import { CompanyService } from '../company/company.service';
import { ActivatedRoute, Router } from '@angular/router';
import {
  isLockForValidationSelector,
  isPrfLocked,
  isValidationJobIdNotEmptySelector,
} from '../company/premiumreport/data-access/premium-report.selectors';
import { Store } from '@ngrx/store';
import { AppService } from '../app.service';
import {
  selectPrfNumber,
  selectPrfYear,
} from '../store/selectors/app.selector';
import { isProgressPage as isProgressPageUtil } from '../shared/utils/navigation-utils';

@Component({
  selector: 'app-side-bar',
  templateUrl: './side-bar.component.html',
  styleUrl: './side-bar.component.scss',
  standalone: false,
})
export class SideBarComponent {
  subscription: Subscription;
  premiumreportCompleted: boolean = false;
  premiumreportInProgress: boolean = false;

  annualstatementCompleted: boolean = false;
  annualstatementInProgress: boolean = false;
  disable: boolean = true;
  disablePReport: boolean = true;
  disableAStatement: boolean = true;
  isLockedForValisation$ = this.store.select(isLockForValidationSelector); //.pipe(map(x => { debugger; return Boolean(x); }))

  isValidationJobIdNotEmptySelector$ = this.store.select(
    isValidationJobIdNotEmptySelector
  );

  priorYearComparisonCompleted: boolean = false;
  priorYearComparisonInProgress: boolean = false;
  disablePriorYearComparison: boolean = true;

  disableAStatementComparison: boolean = true;
  isReadOnlyAdmin: boolean;
  isPrfSubmitReport: boolean = false;
  prfYear: number;
  prfNumber: string;
  private readonly destroy$ = new Subject<void>();

  constructor(
    private companyService: CompanyService,
    private router: Router,
    private activeRoute: ActivatedRoute,
    private store: Store,
    private appService: AppService
  ) {}

  ngOnInit(): void {
    this.isReadOnlyAdmin = this.appService.isReadonlyAdmin;

    this.store.select(selectPrfYear).subscribe((year) => {
      this.prfYear = year;
    });

    this.store.select(selectPrfNumber).subscribe((prfNumber) => {
      this.prfNumber = prfNumber;
    });

    combineLatest([
      this.store.select(selectPrfYear),
      this.store.select(selectPrfNumber),
    ]).subscribe(([year, prfNumber]) => {
      if (year && prfNumber) {
        this.companyService.loadPremiumData();
      }
    });
    combineLatest([
      this.store.select(isLockForValidationSelector),
      this.store.select(isPrfLocked),
    ])
      .pipe(takeUntil(this.destroy$))
      .subscribe(([isValidationLocked, prfLocked]) => {
        this.isPrfSubmitReport = !isValidationLocked && prfLocked;
      });
    this.companyService.premiumreportCompleted.subscribe((result) => {
      this.premiumreportCompleted = result;
      this.disablePReport = false;
    });

    this.companyService.premiumreportInProgress.subscribe((result) => {
      this.premiumreportInProgress = result;
      this.disablePReport = false;
    });

    this.companyService.premiumreportBlocked.subscribe((result) => {
      this.disablePReport = result;
      this.premiumreportInProgress = false;
      this.premiumreportCompleted = false;
    });

    this.companyService.annualstatementCompleted.subscribe((result) => {
      this.annualstatementCompleted = result;
      this.disableAStatement = result;
      if (result) {
        this.disableAStatementComparison = false;
      } else {
        this.disableAStatementComparison = true;
      }
    });

    this.companyService.annualstatementInProgress.subscribe((result) => {
      this.annualstatementInProgress = result;
      this.disableAStatement = false;
    });

    this.companyService.annualstatementBlocked.subscribe((result) => {
      this.disableAStatement = result;
      this.annualstatementInProgress = false;
      this.annualstatementCompleted = false;
    });
    this.companyService.priorYearComparisonCompleted.subscribe((result) => {
      if (result) {
        this.disablePriorYearComparison = false;
      } else {
        this.disablePriorYearComparison = true;
      }
      this.priorYearComparisonCompleted = result;
    });

    this.companyService.priorYearComparisonBlocked.subscribe((result) => {
      this.disablePriorYearComparison = true;
    });

    this.companyService.disablePrf.subscribe((disable) => {
      this.disable = disable;
      this.disableAStatement = disable;
      this.disablePReport = disable;
      this.disablePriorYearComparison = disable;
    });

    this.handleProfileChange();
  }
  ngOnDestroy(): void {
    // Unsubscribe when the component is destroyed
    this.destroy$.next();
    this.destroy$.complete();
  }
  handleProfileChange() {
    if (this.activeRoute.snapshot.queryParams.hasOwnProperty('switchcompany')) {
      setTimeout(() => {
        // ignore api failure redirect
        this.router.navigate(['']);
      }, 300);
    }
  }

  openHelpDocument() {
    this.companyService.getTemplateFile('ScreenHelp.pdf').subscribe({
      next: (resp) => {
        if (resp['message'] == 'Success') {
          let fileurl = resp['templateurl'];
          window.open(fileurl, '_blank');
        }
      },
      error: (error) => {
        this.router.navigate(['/apifailure']);
      },
    });
  }

  isProgressPage(): boolean {
    return isProgressPageUtil(this.router.url);
  }
}
